import React from "react"
import { Bullet as BulletChart } from '@ant-design/plots'

const Bullet = (props) => {
  return (
    <BulletChart {...props} />
  )
}

export default Bullet
